// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".kpi-center-block[data-v-16fcecb2]{bottom:2px;position:absolute;top:75px}.kpi-center-block-content[data-v-16fcecb2]{width:50%;display:inline-block;height:100%}", ""]);
// Exports
module.exports = exports;
